// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".navigation__item a{font-size:1rem;line-height:2rem;color:inherit;font-weight:400}.navigation__item a:hover{color:var(--mint)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
